import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Context } from "../../Context";
import { ApartmentViewContext } from "./context/ApartmentViewContext";
import {
	infoModeName,
	stylesModeName,
	insolationModeName,
} from "./context/contextStrings";
import ApartmentHeadingNew from "./components/ApartmentHeadingNew";
import ApartmentHeading from "./components/ApartmentHeading";
import InfoBlock from "./components/InfoBlock";
import CompartmentsBlock from "./components/CompartmentsBlock";
import CompartmentsBlockWithGrid from "./components/CompartmentsList/CompartmentsBlockWithGrid";
import InsolationController from "./components/InsolationController";
import PlanButtons from "./components/PlanButtons";
import PlanViewer from "./components/PlanViewer";
import BuildingTierList from "./components/BuildingTierList";

import styles from "../../styles/aprt.module.scss";
import ComponentCloseButton from "../ComponentCloseButton";
import ApartmentInfoBlock from "./components/InfoBlockNEW";
import InfoBlockDescription from "./components/InfoBlockDescription";
import PriceInfoBlock from "./components/PriceInfoBlock";
import QueryButtons from "./components/QueryButton";
import ApartmentTopBar from "./components/ApartmentTopBar";
import AdditionalResources from "./components/AdditionalResources";
import ApartmentQueryButton from "./components/ApartmentQueryButton";
import AddSupplementalAreas from "./components/AddSupplementalAreas";
import PlanButtonsNew from "./components/PlanButtonsNew";
import StickyPriceSection from "./components/StickyPriceSection";
import PriceInfoBlockV2 from "./components/PriceInfoBlockSticky";
function ApartmentView() {
  const {
    projectEdifices,
    activeBuilding,
    tiersData,
    // apartmentsData,
    activeApartment,
    setActiveApartment,
    setActiveApartmentHandle,
    isDesktop,
    isMobile,
    projectStyle,
    dataUrl,
    filteredApartmentData,
    apartmentViewRef,
    compartmentsDictionary,
    projectSetup,
    activeApartmentData,
    buildingsData,
  } = useContext(Context);

  // Toggle for testing new Grid UI - set to true to test new component
  const USE_NEW_GRID_UI = true;
  //lokalny kontekst
  const {
    apartmentViewMode,
    setApartmentViewMode,
    apartmentViewInteractions,
    setApartmentViewInteractions,
    insolationAngle,
    urlComboParam, //temporary solution, TODO: refactor to use URL Params from react-router-dom
    setUrlComboParam, //temp
    userSelectedArrangements,
    setUserSelectedArrangements,
  } = useContext(ApartmentViewContext);
  //TODO: important!! use URL Params from react-router-dom instead of temp. urlComboParam; decide if they are handled in this component or in Context.js in App.js

  const [currentArrangements, setCurrentArrangements] = useState([]); ///TODO: should this be in context?

  const { t } = useTranslation();
  const { selectedCompartmentInd, hoveredCompartmentInd } =
    apartmentViewInteractions;

  const currentBuilding = activeBuilding ? activeBuilding : buildingsData[0].name_original;
	
  const querySupplementaryAreasConfig = projectSetup?.units?.query_supplementary_areas || {};
	const querySupplementaryAreas = Object.keys(querySupplementaryAreasConfig).length || 0;


  useEffect(() => {
    if (activeApartment && filteredApartmentData && apartmentViewRef.current) {
      const apartment = filteredApartmentData.find(
        (item) => item.id_original === activeApartment
      );
      // const apartmentRefTier = apartment.ref_tier;
      // const apartmentRefTier = apartment.compartments.find(
      //   (compartment) => compartment.number === 1
      // ).ref_tier;

      const getTierString = (tier) => {
        return tier.toString().padStart(2, "0");
      };

      //TODO temporary solution, refactor to use URL Params from react-router-dom
      setUrlComboParam(null);
      setApartmentViewInteractions((prev) => ({
        ...prev,
        selectedCompartmentInd: null,
      }));
    }
  }, [activeApartment, filteredApartmentData]);

  const encodeCombination = (
    //TEMPORARY FUNC DECLARATION - TODO: import from utils
    arrangementsArray,
    variantsPerElement
  ) => {
    let encodedValue = 0;
    for (let i = 0; i < arrangementsArray.length; i++) {
      let product = 1;
      for (let j = i - 1; j >= 0; j--) {
        product *= variantsPerElement[j];
      }
      encodedValue += arrangementsArray[i] * product;
    }
    return encodedValue;
  };

  const decodeCombination = (encodedValue, variantsPerElement) => {
    //TEMPORARY FUNC DECLARATION - TODO: import from utils
    let arrangementsArray = [];
    let remainingValue = encodedValue;

    for (let i = 0; i < variantsPerElement.length; i++) {
      let product = 1;
      for (let j = variantsPerElement.length - i - 2; j >= 0; j--) {
        product *= variantsPerElement[j];
      }

      arrangementsArray.unshift(Math.floor(remainingValue / product));
      remainingValue %= product;
    }
    return arrangementsArray;
  };

  const getNumbersOfArrangementVersions = (
    activeApartmentData
  ) => {
    const sortedCompartments = activeApartmentData.compartments.sort((a, b) => {
      return parseInt(a.number) - parseInt(b.number);
    });
    const arrangementVersions = sortedCompartments.map(
      (compartment) => compartment.versions
    );
    return arrangementVersions;
  };

  const getStoredArrangements = () => {
    const storedArrangementsJson = localStorage.getItem("arrangements");
    const storedArrangements = storedArrangementsJson
      ? JSON.parse(storedArrangementsJson)
      : [];

    return storedArrangements;
  };

  const getStoredArrangementCombo = (uuid) => {
    const storedArrangements = getStoredArrangements();
    const storedArrangement = storedArrangements.find(
      (combo) => combo.uuid === uuid
    );
    const storedArrangementCombo = storedArrangement?.arrangementCombo;

    return storedArrangementCombo || null;
  };

  const storeArrangementComboLocally = (uuid, arrangementCombo) => {
    const storedArrangements = getStoredArrangements();

    const updatedStoredArrangements = storedArrangements.filter(
      (combo) => combo.uuid !== uuid
    );

    updatedStoredArrangements.push({ uuid, arrangementCombo });

    localStorage.setItem(
      "arrangements",
      JSON.stringify(updatedStoredArrangements)
    );
  };

  useEffect(() => {
    //TODO: most of this logic should be moved to context, and based on URL Params from react-router-dom

    if (!activeApartmentData) return;

    const uuid = activeApartmentData.uuid;
    const arrangementVersions = getNumbersOfArrangementVersions(activeApartmentData);

    /*
    //TODO: important!! use URL Params from react-router-dom instead of temp. urlComboParam; decide if they are handled in this component or in Context.js in App.js
    const urlParams = new URLSearchParams(location.search);
    const combinationParam = urlParams.get('com');
    const uuid = apartmentData.uuid;
    */

    const getArrangementsFromUrlAndStorage = () => {
      //TODO: important!! top priority!! fix this useEffect to work properly.
      //TEMPORARY SOLUTION: APP ALWAYS LOADS DEFAULT SVG, IN DEFAULT ARRANGEMENT
      if (urlComboParam != null) {
        storeArrangementComboLocally(uuid, urlComboParam);
        setCurrentArrangements(
          decodeCombination(parseInt(urlComboParam), arrangementVersions)
        );
        setUserSelectedArrangements(
          decodeCombination(parseInt(urlComboParam), arrangementVersions)
        );
      } else {
        const newCombination = Array(arrangementVersions.length).fill(0); //TODO: important!! check if Clients versions are stored as 0 or 1; do we start with 0 or 1 by default?
        setUrlComboParam(
          encodeCombination(newCombination, arrangementVersions)
        );
        setCurrentArrangements(newCombination);
        setUserSelectedArrangements(newCombination);
      }
    };

    getArrangementsFromUrlAndStorage();
  }, [
    activeApartmentData, 
    urlComboParam
  ]);

	return (
		activeApartment &&
		activeApartmentData && (
      <div
      ref={apartmentViewRef}
       >
      {/* <ApartmentTopBar /> */}
			<div
				// style={{ maxWidth: "1320px", margin: "auto" }}
        className={styles.apartment_view}
			>
				{activeApartmentData && isDesktop && (
          <>
                        {/* <PlanButtonsNew /> */}
						<ComponentCloseButton flag="apartment" />
					<div className={styles.wrapper__desktop}>



            <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end'
            }}>
            <ApartmentHeadingNew />
            <ApartmentHeading
              apartmentData={activeApartmentData} 
              filteredApartmentData={filteredApartmentData}
              setActiveApartment={setActiveApartmentHandle}
              setApartmentViewInteractions={setApartmentViewInteractions}
              projectSetup={projectSetup}
            />
						<div className={styles.lists__block}
            >
							{/* <ApartmentHeading
								apartmentData={activeApartmentData} 
								filteredApartmentData={filteredApartmentData}
								setActiveApartment={setActiveApartmentHandle}
								setApartmentViewInteractions={setApartmentViewInteractions}
                projectSetup={projectSetup}
							/> */}
							{/* <InfoBlock
								isMobile={isMobile}
								apartmentViewMode={apartmentViewMode}
								apartmentData={activeApartmentData}
								selectedCompartmentInd={selectedCompartmentInd}
                tiersData={tiersData}
                projectSetup={projectSetup}
							/> */}
              <ApartmentInfoBlock />
              
              <StickyPriceSection apartmentData={activeApartmentData} />
              {/* <PriceInfoBlockV2/> */}

              {/* <QueryButtons 
                isMobile={isMobile}
								apartmentData={activeApartmentData} 
								dataUrl={dataUrl}
                projectSetup={projectSetup}
              /> */}
              {querySupplementaryAreas > 0 && <AddSupplementalAreas />}
              <InfoBlockDescription />
              {apartmentViewMode.mode === insolationModeName && (
                <InsolationController apartmentData={activeApartmentData} /> 
              )}
							{USE_NEW_GRID_UI ? (
								<CompartmentsBlockWithGrid
									apartmentViewMode={apartmentViewMode}
									apartmentData={activeApartmentData}
								/>
							) : (
								<CompartmentsBlock
									isMobile={isMobile}
									apartmentViewMode={apartmentViewMode}
									apartmentData={activeApartmentData}
									compartmentsDictionary={compartmentsDictionary}
								/>
							)}
              <AdditionalResources />
						</div>
						</div>
						<div className={styles.plan__block}>
							{/* <PlanButtons
								isMobile={isMobile}
								apartmentData={activeApartmentData} 
								dataUrl={dataUrl}
                projectSetup={projectSetup}
							/> */}
                                      <PlanButtonsNew />

							<PlanViewer
								dataUrl={dataUrl}
								currentEdifice={currentBuilding}
								projectStyle={projectStyle}
								currentArrangements={currentArrangements} //TODO: should this rather be in context?
								arrangementVersions={getNumbersOfArrangementVersions(
                  activeApartmentData
								)} //TODO: should this rather be in context?
								apartmentViewMode={apartmentViewMode}
								apartmentData={activeApartmentData}
								insolationAngle={insolationAngle}
								setApartmentViewInteractions={setApartmentViewInteractions}
								selectedCompartmentInd={selectedCompartmentInd}
								hoveredCompartmentInd={hoveredCompartmentInd}
								userSelectedArrangements={userSelectedArrangements}
								setUrlComboParam={setUrlComboParam}
                compartmentsDictionary={compartmentsDictionary}
							/>
						</div>
						<div className={styles.lastColumn}>
							<BuildingTierList
								apartmentData={activeApartmentData}  
								buildingTiers={tiersData}
							/>
						</div>
					</div>
          </>
				)}
				{activeApartmentData && isMobile && (
					<div className={styles.wrapper__desktop}>
						<div className={styles.lists__block}>
							<ApartmentHeading
								apartmentData={activeApartmentData}
								filteredApartmentData={filteredApartmentData}
								setActiveApartment={setActiveApartment}
								setApartmentViewInteractions={setApartmentViewInteractions}
                projectSetup={projectSetup}
							/>
						</div>
						<div className={styles.plan__block}>
							<PlanButtons
								isMobile={isMobile}
								apartmentData={activeApartmentData} 
								dataUrl={dataUrl}
                projectSetup={projectSetup}
							/>
							<PlanViewer
								dataUrl={dataUrl}
								currentEdifice={currentBuilding}
								projectStyle={projectStyle}
								currentArrangements={currentArrangements} //TODO: should this rather be in context?
								arrangementVersions={getNumbersOfArrangementVersions(
                  activeApartmentData
								)} //TODO: should this rather be in context?
								apartmentViewMode={apartmentViewMode}
								insolationAngle={insolationAngle}
								setApartmentViewInteractions={setApartmentViewInteractions}
								selectedCompartmentInd={selectedCompartmentInd}
								hoveredCompartmentInd={hoveredCompartmentInd}
								userSelectedArrangements={userSelectedArrangements}
								setUrlComboParam={setUrlComboParam}
                compartmentsDictionary={compartmentsDictionary}
							/>
						</div>
						<div className={styles.lastColumn}>
							<BuildingTierList
								apartmentData={activeApartmentData}
								buildingTiers={tiersData}
							/>
						</div>
						<div className={styles.lists__block}>
							{apartmentViewMode.mode === insolationModeName && (
								<InsolationController apartmentData={activeApartmentData} />  
							)}
							<InfoBlock
								isMobile={isMobile}
								apartmentViewMode={apartmentViewMode}
								apartmentData={activeApartmentData}
								selectedCompartmentInd={selectedCompartmentInd}
                tiersData={tiersData}
                projectSetup={projectSetup}
							/>
							<CompartmentsBlock
								isMobile={isMobile}
								apartmentViewMode={apartmentViewMode}
								apartmentData={activeApartmentData}
                compartmentsDictionary={compartmentsDictionary}
							/>
						</div>
					</div>
				)}
			</div>
		</div>)
	);
}

export default ApartmentView;
